const shimmerHeightMap = {
    1: "200px",
    2: "240px"
};

export { shimmerHeightMap };
